import { createQuery } from '$lib/api/tanstack-query';

import type { GetEnvironmentResponse } from '@viamrobotics/web-client/environment/v1/environment';

import { useAuthContext } from '$lib/auth';

import { useEnvironmentClient } from './env-client';

export type AppEnvironment = GetEnvironmentResponse['environment'];

export const createGetEnvironmentQuery = () => {
  const client = useEnvironmentClient();
  const { getOptionalRPCOptions } = useAuthContext();

  const options = {
    queryKey: ['environment'],
    staleTime: Number.POSITIVE_INFINITY,
    queryFn: async () => {
      const rpcOptions = await getOptionalRPCOptions();
      const { response } = await client.getEnvironment({}, rpcOptions);

      return response.environment;
    },
  };

  return createQuery(options);
};
